import CoCartAPI from '@cocart/cocart-rest-api'
import axios from 'axios'
import { calls } from '../utils/calls.js'
import { APP_URL } from '../utils/config.js'
import { createError } from '../utils/utils.js'

const CoCart = new CoCartAPI({
  url: APP_URL,
})
export const setSelectedType = (selectedType, canProceed = null) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_TYPE',
      payload: { selectedType: selectedType, canProceed },
    })
  }
}

export const setSelectedShape = (selectedShape, canProceed = null) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_SHAPE',
      payload: { selectedShape: selectedShape, canProceed },
    })
  }
}

export const setAdditionalShape = (selectedShape) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_ADDITIONAL_SELECTED_SHAPE',
      payload: { selectedShape: selectedShape },
    })
  }
}

export const setSelectedSet = (selectedSet, canProceed = null) => {
  return (dispatch) => {
    dispatch({ type: 'SET_SELECTED_SET', payload: { selectedSet: selectedSet, canProceed } })
  }
}

export const setSelectedFastener = (selectedFastener, canProceed = null) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_FASTENER',
      payload: { selectedFastener: selectedFastener, canProceed },
    })
  }
}

export const setSelectedFilling = (selectedFilling) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_FILLING',
      payload: { selectedFilling: selectedFilling },
    })
  }
}

export const setAdditionalFillingOptions = (selectedFilling) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_ADDITIONAL_FILLING_OPTION',
      payload: { selectedFilling: selectedFilling },
    })
  }
}

export const setFastenerPlacement = (fastenerPlacement) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_FASTENER_PLACEMENT',
      payload: { fastenerPlacement: fastenerPlacement },
    })
  }
}

export const setSelectedStyle = (selectedStyle) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_STYLE',
      payload: { selectedStyle: selectedStyle },
    })
  }
}

export const setCanProceedToNextStep = (canProceed) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CAN_PROCEED_TO_NEXT_STEP', payload: { canProceed: canProceed } })
  }
}

export const setSelectedDimensions = (selectedDimensions) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_DIMENSIONS',
      payload: { selectedDimensions: selectedDimensions },
    })
    return Promise.resolve()
  }
}

export const setZipperOrientation = (zipperOrientation) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_ZIPPER_ORIENTATION',
      payload: { zipperOrientation: zipperOrientation },
    })
  }
}

export const setSelectedFabric = (selectedFabric, canProceed = null) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_FABRIC',
      payload: { selectedFabric: selectedFabric, canProceed },
    })
  }
}

export const setSingleFabric = (selectedFabric) => {
  return (dispatch) => {
    dispatch({ type: 'SET_SINGLE_FABRIC', payload: { selectedFabric: selectedFabric } })
  }
}

export const setFabricDirection = (fabricDirection) => {
  return (dispatch) => {
    dispatch({ type: 'SET_FABRIC_DIRECTION', payload: { fabricDirection: fabricDirection } })
  }
}

export const setSelectedCordFabric = (selectedFabric, canProceed = null) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_CORD_FABRIC',
      payload: { selectedFabric: selectedFabric, canProceed },
    })
  }
}

export const setSingleCordFabric = (selectedFabric) => {
  return (dispatch) => {
    dispatch({ type: 'SET_SINGLE_CORD_FABRIC', payload: { selectedFabric: selectedFabric } })
  }
}

export const setCordFabricDirection = (fabricDirection) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_CORD_FABRIC_DIRECTION',
      payload: { fabricDirection: fabricDirection },
    })
  }
}

export const resetGeneral = () => {
  return (dispatch) => {
    dispatch({ type: 'RESET_GENERAL' })
  }
}

export const addYardsToCart = (cartKey, type, cushionItemData, qty, successCallback) => {
  return (dispatch) => {
    dispatch({ type: 'ADD_TO_CART_YARDS' })

    CoCart.post('cart/add-item', {
      id: type.id.toString(),
      quantity: qty ? qty : '1',
      item_data: cushionItemData,
    })
      .then((res) => {
        if (!cartKey) {
          localStorage.setItem('cartKey', res.data.cart_key)
          cartKey = res.data.cart_key
        }

        dispatch(setAddedToCartMessageYards(type.id)).then(() => {
          setTimeout(() => {
            dispatch(setAddedToCartMessageYards(type.id))
          }, 3000)
        })

        dispatch({ type: 'ADD_TO_CART_YARDS_SUCCESS' })

        if (successCallback) {
          successCallback(qty)
        }
      })
      .catch(() => {
        dispatch({ type: 'ADD_TO_CART_YARDS_FAILED' })
      })
  }
}

export const addToCart = (cartKey, type, cushionItemData, swatch = false, productQty, successCallback = null) => {
  return (dispatch) => {
    dispatch({ type: 'ADD_TO_CART' })
    CoCart.post('cart/add-item', {
      id: type.id.toString(),
      quantity: productQty ? productQty.toString() : '1',
      item_data: cushionItemData,
    })
      .then((res) => {
        if (!cartKey) {
          localStorage.setItem('cartKey', res.data.cart_key)
          cartKey = res.data.cart_key
        }
        if (!swatch) {
          window.location = `${APP_URL}/cart`
        } else {
          dispatch(setAddedToCartMessage(type.id)).then(() => {
            setTimeout(() => {
              dispatch(setAddedToCartMessage(type.id))
            }, 3000)
          })
        }

        dispatch({ type: 'ADD_TO_CART_SUCCESS' })

        if (successCallback) {
          successCallback()
        }
      })
      .catch(() => {
        dispatch({ type: 'ADD_TO_CART_FAILED' })
      })
  }
}

const setAddedToCartMessage = (fabricId) => (dispatch) => {
  dispatch({ type: 'SET_ADDED_TO_CART_MESSAGE', payload: { fabricId } })
  return Promise.resolve()
}

const setAddedToCartMessageYards = (fabricId) => (dispatch) => {
  dispatch({ type: 'SET_ADDED_TO_CART_MESSAGE_YARDS', payload: { fabricId } })
  return Promise.resolve()
}

export const setBeenThrough = (beenThrough) => (dispatch) => {
  dispatch({ type: 'SET_BEEN_THROUGH', payload: { beenThrough } })
}

export const setCategory = (category) => (dispatch) => {
  dispatch({ type: 'SET_CATEGORY', payload: { category } })
}

export const setCustomTemplateTutorialVisible = () => (dispatch) => {
  dispatch({ type: 'SET_CUSTOM_TEMPLATE_TUTORIAL_VISIBLE' })
}

export const setCordingModalVisible = () => (dispatch) => {
  dispatch({ type: 'SET_CORDING_MODAL_VISIBLE' })
}

export const setAcceptedCordingWarning = (value) => (dispatch) => {
  dispatch({ type: 'SET_ACCEPTED_CORDING_WARNING', payload: { acceptedCordingWarning: value } })
}

export const setCordingModalVisibleValue = (value) => (dispatch) => {
  dispatch({ type: 'SET_CORDING_MODAL_VISIBLE_VALUE', payload: { cordingModalVisible: value } })
}

export const setIndividualRoundedBack = (individualRoundedBack) => (dispatch) => {
  dispatch({ type: 'SET_INDIVIDUAL_ROUNDED_BACK', payload: { individualRoundedBack } })
}

export const setIndividualRoundedSeat = (individualRoundedSeat) => (dispatch) => {
  dispatch({ type: 'SET_INDIVIDUAL_ROUNDED_SEAT', payload: { individualRoundedSeat } })
}

export const getKits = () => {
  return (dispatch) => {
    return axios(calls.getKits())
      .then((kits) => {
        dispatch({ type: 'SET_KITS', payload: { kits: kits.data } })
      })
      .catch((err) => createError(err))
  }
}

export const getPrice = (params) => {
  return (dispatch) => {
    return axios(calls.getPrice(params))
      .then((totalPrice) => {
        dispatch({ type: 'SET_TOTAL_PRICE', payload: { totalPrice: totalPrice.data } })
      })
      .catch((err) => createError(err))
  }
}

export const getProductById = (id) => {
  return axios(calls.getProductById(id))
    .then((product) => {
      return product.data
    })
    .catch((err) => createError(err))
}

export const getFabricById = (id) => {
  return axios(calls.getFabrictById(id))
    .then((fabric) => {
      return fabric.data
    })
    .catch((err) => createError(err))
}

export const setRemoveItem = (removeItem) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_REMOVE_ITEM',
      payload: { removeItem: removeItem },
    })
  }
}

export const setScrollToFunction = (enableScrollTo) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_ENABLE_SCROLL_TO',
      payload: { enableScrollTo: enableScrollTo },
    })
  }
}

export const setProductQty = (productQty) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_PRODUCT_QTY',
      payload: { productQty: productQty },
    })
  }
}

export const setIsConnected = (isConnected) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_IS_CONNECTED',
      payload: { isConnected: isConnected },
    })
  }
}

export const deleteItemFromCart = (itemId, wpnonce) => {
  return axios(calls.deleteItemFromCart(itemId, wpnonce))
    .then((res) => {
      return res.data
    })
    .catch((err) => createError(err))
}

export const setCustomTamplateNumberOfFasteners = (noOfFasteners) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_CUSTOM_TAMPLATE_NO_OF_FASTENERS',
      payload: { noOfFasteners: noOfFasteners },
    })
  }
}

export const setScrollPosition = (scrollPosition) => ({
  type: 'SET_SCROLL_POSITION',
  payload: scrollPosition,
})
